type PossibleMessageType = 'text' | 'file' | 'image' | 'video' | 'system' | 'broadcast';

export type SendNewMessage = {
  room_id: string;
  sender_id: string;
  receiver_id: string;
  sender_type: string;
  message: string | File;
  message_id: string;
  updated_at: number;
  messageType: PossibleMessageType;
  fileInfo?: MessageFileInfoType;
  locale: string;
  notifyMessage?: string;
};

export type ChatMessageData = {
  id: string;
  room_id: string;
  sender_id: string;
  receiver_id: string;
  message: string | File;
  /**
   * This property is specifically for broadcast messages.
   * It allows a separate file (e.g., an image URL) to be associated with the broadcast message,
   * while the 'message' property contains the text content.
   */
  file_url?: string | null;
  updated_at: number;
  status: 'loading' | 'sent' | 'viewed';
  messageType: PossibleMessageType;
  fileInfo?: MessageFileInfoType;
  buttons?: { text: string; link: string }[] | null;
  notifyMessage?: string;
};

export type MessageFileInfoType = {
  originalName: string;
  size: number;
  width?: number;
  height?: number;
};

export interface ChatMessagesStore {
  entities: {
    [key: string]: {
      messages: ChatMessageData[];
      offset: number;
      isInfiniteDisabled: boolean;
    };
  };
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
}

export const BROADCAST_MESSAGE_SENDER_ID = 'MINDLY_BROADCAST_CHAT';
